<template>
  <div class="vue-outer-wrap">
    <div v-if="user" class="create-utility-type-container">
      <span
      v-if="errorMessage"
      v-bind:class="{fade: fadeErrorMessage}"
      class="error-message">{{errorMessage}}</span>
      <div class="header">Create Utility Type</div>
        <div class="controls-container">
          <!-- name -->
          <div class="control-container">
            <div class="control utility-type-name">
              <label for="utility-type">Name:</label>
              <input ref="newUtilityTypeName" v-model="newUtilityType.name" placeholder="Utility type name" type="text" class="name" v-bind:disabled="updatingUtilityType" @keyup="onNewUtilityTypeNameChange($event)">
            </div>
          </div>
          <!-- code -->
          <div class="control-container">
            <div class="control utility-type-code">
              <label for="utility-type">Code:</label>
              <input v-model="newUtilityType.code" placeholder="Utility type code" type="text" class="code" v-bind:disabled="updatingUtilityType">
            </div>
          </div>
          <!-- description -->
          <div class="control-container">
            <div class="control utility-type-description">
              <label for="utility-type">Description:</label>
              <input v-model="newUtilityType.description" placeholder="Utility type description" type="text" class="description" v-bind:disabled="updatingUtilityType">
            </div>
          </div>
          <div class="buttons-container">
            <b-spinner v-if="updatingUtilityType" class="ajax-spinner"></b-spinner>
            <b-button
            class="cancel"
            v-if="!updatingUtilityType"
            v-on:click="cancelUtilityTypeEdit()"
            v-bind:disabled="updatingUtilityType">Cancel</b-button>
            <b-button
            class="submit"
            v-if="!updatingUtilityType"
            v-on:click="submitUtilityType()"
            v-bind:disabled="updatingUtilityType || !newUtilityType.name || !newUtilityType.code">Create Utility Type</b-button>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue';
import { Auth } from 'aws-amplify';
import API from "@/services/api";

export default {
  name: 'CreateUtilityType',
  components: {

  },
  props: {
    hide: Function,
    createUtilityTypeSuccess: Function
  },
  data() {
    return {
      user: undefined,
      updatingUtilityType: false,
      errorMessage: false,
      fadeErrorMessage: false,
      newUtilityType: {},
      placeholderUtilityType: {name: ''}
    }
  },
  async created() {

  },
  beforeCreate() {
    Auth.currentAuthenticatedUser()
      .then(user => {
          this.user = user;
      })
      .catch(() => console.log('not signed in...'))
  },
  methods: {
    cancelUtilityTypeEdit(){
      this.hide();
    },
    resetPlaceholderUtilityType() {
      this.placeholderUtilityType = {name: ''};
    },
    onNewUtilityTypeNameChange (event) {
      if (!event.target.value || !event.target.value.length) {
        this.cancelUtilityTypeEdit();
      }
    },
    submitUtilityType(){
      this.updatingUtilityType = true;

      const postData = {
        name: this.newUtilityType.name,
        code: this.newUtilityType.code,
        description: this.newUtilityType.description
      };

      try {
        API.CreateUtilityType(postData).then((data) => {
          this.updatingUtilityType = false;
          this.createUtilityTypeSuccess(data);
          this.hide();
        }, err => {
          console.error('CreateUtilityType - ERROR');
          console.dir(err);

          this.updatingUtilityType = false;

          if (err
          && err.response
          && err.response.data) {
            this.errorMessage = err.response.data;
          } else {
              this.errorMessage = `Error updating ${this.newUtilityType.name}`;
          }

          setTimeout(() => {this.fadeErrorMessage = true}, 3000);
          setTimeout(() => {
            this.errorMessage = '';
            this.fadeErrorMessage = false;
          }, 6000);
        })
      } catch (err) {
          this.updatingUtilityType = false;
          console.error('POST ERROR!');
          console.dir(err);
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../../assets/css/partials/_variables.scss";

  .create-utility-type-container{
    position: relative;
    width: 100%;
    margin: 0 auto 20px;

    input[type="text"] {
      width: 100%;
    }

    .placeholder{
      height: 10px;
      background-color: #002D68;
      border: none;
    }

    .b-icon{
      position: absolute;
      top: 0;
      right: 0;
      font-weight: bold;
      color: #002D68;
      font-size: 28px;
    }

    .utility-type-name{
      color: #333;
    }

    .success-message{
      position: absolute;
      top: 0;
      right: 23px;
      font-weight: bold;
      color: #196319;
      -webkit-transition: all 2s ease-in-out;
      -moz-transition: all 2s ease-in-out;
      -o-transition: all 2s ease-in-out;
      transition: all 2s ease-in-out;

      &.fade {
          opacity: 0;
      }
    }

    .error-message{
      position: absolute;
      top: 0;
      right: 23px;
      font-size: 18px;
      font-weight: bold;
      color: #800000;
      -webkit-transition: all 2s ease-in-out;
      -moz-transition: all 2s ease-in-out;
      -o-transition: all 2s ease-in-out;
      transition: all 2s ease-in-out;

      &.fade {
          opacity: 0;
      }
    }

    .header{
      margin: 0;
      font-weight: 500;
      color: #231f20
    }

    .controls-container {
      .control{
        width: 80%;
        margin-bottom: 20px;
        padding: 10px;
        background-color: $modalGrey;

        input[type="text"] {
          width: 100%;
          height: 40px;
          padding-left: 10px;
          border: none;
        }
      }

      &.utility-select{
        select{
          margin-left: 5px; 
        } 
      }

      .control-container{
        margin: 20px 0;
      }

      label {
        margin-right: 10px;
        font-weight: bold;
      }
    }

    .buttons-container{
      padding: 10px;

      .ajax-spinner{
        position: relative;
        top: 6px;
        right:15px;
        color: #fbd850;
      }

      .submit{
        margin-left: 10px;
      }
    }
  }
</style>
